import type { PermissionSetEntity } from '@omnea-app/authz'
import type { QueryClient } from '@tanstack/react-query'

const RECORD_ACCESS_QUERY_KEY = 'RecordAccess'

export const recordAccessQueryKey = (userId: string, entity: PermissionSetEntity, recordId: string) =>
  [RECORD_ACCESS_QUERY_KEY, userId, entity, recordId] as const

export const isRecordAccessQueryKey = (queryKey: readonly unknown[]): boolean => queryKey[0] === RECORD_ACCESS_QUERY_KEY

/** Call after a write that changes who may do what to a record, such as a grant or a parent link; cached answers stay otherwise. */
export const invalidateRecordAccess = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({ queryKey: [RECORD_ACCESS_QUERY_KEY] })
